import './List.sass'

const List = () => {
  return (
    <div className='list'>List</div>
  )
}

export default List